import { combineReducers } from 'redux';

import apiError from './apiError';
import dashboard from './dashboard';
import dealerName from './dealerName';
import fetching from './fetching';
import modalSelect from './modalSelect';
import select from './select';
import updating from './updating';

/**
 * @typedef {{
 *   select: import('./select').SelectState,
 *   fetching: boolean,
 *   updating: boolean,
 *   apiError: string,
 *   dashboard: import('./dashboard').DashboardState,
 *   dealerName: import('./dealerName').State,
 *   modalSelect: import('./modalSelect').State,
 * }} DealersUiReducer
 * */

export default combineReducers({
  select,
  fetching,
  updating,
  apiError,
  dashboard,
  dealerName,
  modalSelect,
});
